import script from "./FeedUrls.vue?vue&type=script&lang=js"
export * from "./FeedUrls.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__